import React, { useState, useCallback } from "react";
import { Alert } from "antd";
import ShipmentRequirementsSummary from "../ShipmentRequirementsSummary";
import EnterExchangeETAsInputForm from "./EnterExchangeETAsInputForm";
const EnterExchangeETAs = ({ exchangeShipmentData, mainShipmentData, createSingleShipmentPropertyValueUpdater, setReturningFromExchangeShipment, }) => {
    const [hasReviewedRequirements, setHasReviewedRequirements] = useState(false);
    const [hasScrolledToBottomOfRequirements, setHasScrolledToBottomOfRequirements] = useState(false);
    const handleReviewRequirementsChecked = useCallback((checked) => {
        setHasReviewedRequirements(checked);
        setHasScrolledToBottomOfRequirements(hasScrolledToBottomOfRequirements || checked);
    }, [hasScrolledToBottomOfRequirements]);
    if (!exchangeShipmentData)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(ShipmentRequirementsSummary, { shipmentsList: [exchangeShipmentData], hasCheckedAllVehicles: hasReviewedRequirements, setHasCheckedAllVehicles: handleReviewRequirementsChecked, setHasScrolledToBottomOfRequirements: setHasScrolledToBottomOfRequirements }),
        !hasReviewedRequirements ? (React.createElement("div", { style: { marginTop: "16px" } },
            React.createElement(Alert, { type: "warning", banner: true, message: "Please scroll to the bottom of the list above, and check the box to continue." }))) : (React.createElement("div", { style: { height: "54px" } })),
        React.createElement(EnterExchangeETAsInputForm, { exchangeShipmentData: exchangeShipmentData, mainShipmentData: mainShipmentData, createSingleShipmentPropertyValueUpdater: createSingleShipmentPropertyValueUpdater, setReturningFromExchangeShipment: setReturningFromExchangeShipment, confirmDisabled: !hasReviewedRequirements })));
};
EnterExchangeETAs.defaultProps = {
    exchangeShipmentData: null,
};
export default EnterExchangeETAs;
